import React from 'react';
import i18 from '../../../i18';
import Modal from 'react-modal';
import Field from "../../common/Field";
import Validator from "../../common/Validator";
import api from "../../../source/api";
import Reflux from "reflux";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

class RuleUpdateModal extends Reflux.Component {

    constructor(props) {
        super(props);
        this.state = {
            config: props.config,
            rule: props.rule,
            vatCollectorCodes: props.vatCollectorCodes,
            fields: {
                supplier_name: {value: props.rule.supplier_name, error: '', role: {required: false}},
                item_name: {value: props.rule.item_name, error: '', role: {required: false}},
                main_bookkeeping_number: {value: props.rule.main_bookkeeping_number, error: '', role: {required: true}},
                vat: {value: props.rule.vat, error: '', role: {required: true}},
                vat_degree: {value: props.rule.vat_degree, error: '', role: {required: true}},
                vat_collector_id: {value: props.rule.vat_collector_id, error: '', role: {required: true}},
                type: {value: props.rule.type, error: '', role: {required: true}},
            },
        }
    }

    updateRule = () => {
        let validatorResponse = Validator.validate(this.state.fields);
        if (validatorResponse.error) {
            this.setState(validatorResponse)
            return;
        }

        let postData = {
            supplier_name: this.state.fields.supplier_name.value,
            item_name: this.state.fields.item_name.value,
            main_bookkeeping_number: this.state.fields.main_bookkeeping_number.value,
            vat: this.state.fields.vat.value,
            vat_degree: this.state.fields.vat_degree.value,
            type: this.state.fields.type.value,
            vat_collector_id: this.state.fields.vat_collector_id.value
        };

        this.closeModal();

        api.put('supplier/' + this.state.config.company_id + '/rule/update/' + this.state.rule.id, postData)
            .then((response) => {
                this.props.updateRules(response.data.supplierRules);
                this.props.notifySuccess('Szabály szerkesztése sikeres.');
            })
            .catch(() => this.props.notifyError('Szabály mentése sikertelen.'));
    }

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    };

    onElementChange = (event) => {
        let fields = this.state.fields;
        fields[event.target.name].value = event.target.value;
        this.setState({fields: fields})
    };

    closeModal = () => {
        this.props.editRule(null)
    };

    render = () => {
        if (!this.state.rule) {
            return null;
        }

        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => this.closeModal()}
                style={customStyles}>
                <h4>{'#' + this.state.rule.id + ' ' + i18.COMMON._editRuleText}</h4>
                <div className='modal-body'>
                    <Field
                        type='text' id='supplier_name' name='supplier_name'
                        label={i18.SUPPLIER._typeOfTraffic} classLabel='control-label margin-bottom-2 margin-top-10'
                        classInput='form-control' setValue={this.setValue.bind(this)}
                        state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                    <Field
                        type='text' id='item_name' name='item_name'
                        label={i18.SUPPLIER._typeOfTraffic} classLabel='control-label margin-bottom-2 margin-top-10'
                        classInput='form-control' setValue={this.setValue.bind(this)}
                        state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                    <Field
                        type='text' id='vat' name='vat'
                        label={i18.SUPPLIER._VAT} classLabel='control-label margin-bottom-2 margin-top-10'
                        classInput='form-control' setValue={this.setValue.bind(this)}
                        state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                    <Field
                        type='text' id='main_bookkeeping_number' name='main_bookkeeping_number'
                        label={i18.SUPPLIER._mainBookNumber} classLabel='margin-top-10 margin-bottom-2 control-label'
                        classInput='form-control' setValue={this.setValue.bind(this)}
                        state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                    <Field
                        type='text' id='vat_degree' name='vat_degree'
                        label={i18.SUPPLIER._vatDegreeNumber} classLabel='margin-top-10 margin-bottom-2 control-label'
                        classInput='form-control' setValue={this.setValue.bind(this)}
                        state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                    <label htmlFor="vat_collector_id" className="margin-top-10 margin-bottom-2 control-label">{i18.SUPPLIER._collectorCode}</label>
                    <select value={this.state.fields.vat_collector_id.value}
                            name='vat_collector_id'
                            id='vat_collector_id'
                            onChange={(codeevent) => this.onElementChange(codeevent)}
                            className='minimal-100  form-control'>
                        <option value='' key='0'>Kérjük válasszon</option>
                        {this.state.vatCollectorCodes.map((el) => {
                            return (
                                <option
                                    value={el.id}
                                    key={el.id}>
                                    {el.code}&nbsp;({el.title})
                                </option>
                            )
                        })}
                    </select>
                    <label htmlFor="type" className="margin-top-10 margin-bottom-2 control-label">{i18.COMMON._typeOfRule}</label>
                    <select value={this.state.fields.type.value}
                            name='type'
                            id='type'
                            onChange={(codeevent) => this.onElementChange(codeevent)}
                            className='minimal-100  form-control'>
                        <option value="temporarily">{i18.COMMON._temporarirlyRule}</option>
                        <option value="final">{i18.COMMON._finalRule}</option>
                    </select>
                </div>

                <div className='modal-footer text-center'>
                    <a onClick={() => this.updateRule()} className='btn btn-success btn-sm mr-2'>{i18.COMMON._save}</a>
                    <a onClick={() => this.closeModal()} className='btn btn-danger btn-sm'>{i18.COMMON._close}</a>
                </div>
            </Modal>
        </div>
    }
}

export default RuleUpdateModal


// WEBPACK FOOTER //
// ./src/components/supplier/Rules/RuleUpdateModal.js